import '../styles/PageGlobal.css';
import './AdresseListFournisseurPage.css';
import React, { useState, useEffect, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AdresseService } from '../services/AdresseService.js';
import { ClientService } from '../services/ClientService.js';
import { FournisseurService } from '../services/FournisseurService.js';

export default function AdresseNewPage() {
  const { adressholdertype } = useParams();
  const navigate = useNavigate();
  const adresseHolder = (typeof adressholdertype === "string" ? adressholdertype.trim().toLowerCase() : "client");
  
  const adresseService = useMemo(() => new AdresseService(), []);
  const clientService = useMemo(() => new ClientService(), []);
  const fournisseurService = useMemo(() => new FournisseurService(), []);

  const [loading, setLoading] = useState(false);
  const [loadingEntities, setLoadingEntities] = useState(true);
  const [error, setError] = useState(null);
  const [entities, setEntities] = useState([]);

  // 🟢 Valeur par défaut ajoutée pour 'type'
  const [form, setForm] = useState({
    type: 'LIVRAISON', 
    adresse1: '', 
    adresse2: '', 
    codePostal: '', 
    ville: '', 
    pays: 'France',
    selectedEntityId: ''
  });

  useEffect(() => {
    const fetchEntities = async () => {
      setLoadingEntities(true);
      try {
        if (adresseHolder === 'client') {
          const data = await (clientService.getAllClients ? clientService.getAllClients() : clientService.getAll());
          setEntities(data || []);
        } else {
          const data = await fournisseurService.getAllFournisseurs();
          setEntities(data || []);
        }
      } catch (err) {
        setError("Erreur lors du chargement de la liste : " + err.message);
      } finally {
        setLoadingEntities(false);
      }
    };
    fetchEntities();
  }, [adresseHolder, clientService, fournisseurService]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!form.selectedEntityId) {
      setError(`Veuillez sélectionner un ${adresseHolder}.`);
      return;
    }
    if (!form.adresse1 || !form.codePostal || !form.ville) {
      setError("Veuillez remplir les champs obligatoires (Adresse 1, Code Postal, Ville).");
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const payload = {
        type: form.type, // Enverra "LIVRAISON", "FACTURATION" ou "SIEGE_SOCIAL"
        adresse1: form.adresse1,
        adresse2: form.adresse2,
        codePostal: form.codePostal,
        ville: form.ville,
        pays: form.pays,
        clientId: adresseHolder === 'client' ? parseInt(form.selectedEntityId, 10) : null,
        fournisseurId: adresseHolder === 'fournisseur' ? parseInt(form.selectedEntityId, 10) : null
      };

      await adresseService.createAdresse(payload);
      alert("Adresse créée avec succès !");
      navigate(-1);
    } catch (err) {
      console.error(err);
      setError(err.message || "Erreur lors de la création");
    } finally {
      setLoading(false);
    }
  };

  if (loadingEntities) {
    return <div className="containerMain adresse-form-container"><div className="adresse-status adresse-status-loading">Chargement des entités…</div></div>;
  }

  return (
    <div className="containerMain adresse-form-container">
      <h1 className="adresse-form-title">
        {adresseHolder === "fournisseur" ? "Nouvelle adresse fournisseur" : "Nouvelle adresse client"}
      </h1>

      {error && <div className="adresse-error">{error}</div>}

      <div className="adresse-form">
        <div className="adresse-row">
          <label>{adresseHolder === "fournisseur" ? "Fournisseur *" : "Client *"}</label>
          <select 
            name="selectedEntityId"
            value={form.selectedEntityId} 
            onChange={handleChange} 
            required 
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '14px' }}
          >
            <option value="">-- Sélectionnez un {adresseHolder} --</option>
            {entities.map(entity => (
              <option key={entity.id} value={entity.id}>
                {entity.societe1 || entity.nom || entity.raisonSociale || `Entité #${entity.id}`}
                {entity.email && ` - ${entity.email}`}
              </option>
            ))}
          </select>
        </div>

        {/* 🟢 REMPLACÉ PAR UN MENU DÉROULANT (SELECT) */}
        <div className="adresse-row">
          <label>Type d'adresse *</label>
          <select 
            name="type" 
            value={form.type} 
            onChange={handleChange} 
            required
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '14px' }}
          >
            <option value="LIVRAISON">Livraison</option>
            <option value="FACTURATION">Facturation</option>
            <option value="SIEGE_SOCIAL">Siège Social</option>
          </select>
        </div>

        <div className="adresse-row">
          <label>Adresse 1 *</label>
          <input type="text" name="adresse1" value={form.adresse1} onChange={handleChange} required />
        </div>

        <div className="adresse-row">
          <label>Adresse 2</label>
          <input type="text" name="adresse2" value={form.adresse2} onChange={handleChange} />
        </div>

        <div className="adresse-row">
          <label>Code Postal *</label>
          <input type="text" name="codePostal" value={form.codePostal} onChange={handleChange} required />
        </div>

        <div className="adresse-row">
          <label>Ville *</label>
          <input type="text" name="ville" value={form.ville} onChange={handleChange} required />
        </div>

        <div className="adresse-row">
          <label>Pays *</label>
          <input type="text" name="pays" value={form.pays} onChange={handleChange} required />
        </div>
      </div>

      <div className="adresse-footer">
        <button className="adresse-btn adresse-btn-blue" onClick={handleSave} disabled={loading}>
          {loading ? 'Enregistrement…' : 'Enregistrer'}
        </button>
        <button className="adresse-btn adresse-btn-grey" onClick={() => navigate(-1)} disabled={loading}>
          Annuler
        </button>
      </div>
    </div>
  );
}